<template>
  <div class="phone-input">
    <rich-validator
      :model="internalData"
    >
      <rich-input
        v-model="internalData"
        :placeholder="placeholder || gettext('请输入')"
      >
        <div slot="prepend" class="input-prepend">
          <span>{{preText}}</span>
        </div>
      </rich-input>
    </rich-validator>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'PhoneInput',
  props: {
    value: {
      required: true,
      type: String,
      default: ''
    },
    preText: {
      type: String,
      default: '+52'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      internalData: this.value
      // rules: {
      //   pattern: /^1{10}$/
      // },
      // messages: {
      //   pattern: this.gettext('首位必须是1')
      // }
    }
  },
  watch: {
    value (nVal) {
      this.internalData = nVal
    },
    internalData (nVal) {
      this.$emit('input', nVal)
    }
  }
}
</script>

<style lang="scss">
  .phone-input {
    .input-prepend {
      padding: 10Px;
    }
  }
</style>
